import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import * as types from './types';
import * as actions from './actions';
import { cloudResourcesApi } from '../../containers/CloudResources/api/cloudResourcesApi';

// ── Fetch Policies ──────────────────────────────────────────────

function* fetchPoliciesSaga(action) {
  try {
    const response = yield call(cloudResourcesApi.listPolicies, action.payload);
    yield put(actions.fetchPoliciesSuccess(response.data));
  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Failed to fetch policies';
    yield put(actions.fetchPoliciesFailure(errorMsg));
    message.error(errorMsg);
  }
}

// ── Fetch Single Policy ─────────────────────────────────────────

function* fetchPolicySaga(action) {
  try {
    const response = yield call(cloudResourcesApi.getPolicy, action.payload);
    yield put(actions.fetchPolicySuccess(response.data));
  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Failed to fetch policy';
    yield put(actions.fetchPolicyFailure(errorMsg));
    message.error(errorMsg);
  }
}

// ── Create Policy ───────────────────────────────────────────────

function* createPolicySaga(action) {
  try {
    const { data, callback } = action.payload;
    const response = yield call(cloudResourcesApi.createPolicy, data);
    yield put(actions.createPolicySuccess(response.data));
    message.success('Policy created successfully');

    if (callback) {
      callback(response.data);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Failed to create policy';
    yield put(actions.createPolicyFailure(errorMsg));
    message.error(errorMsg);
  }
}

// ── Update Policy ───────────────────────────────────────────────

function* updatePolicySaga(action) {
  try {
    const { id, data, callback } = action.payload;
    const response = yield call(cloudResourcesApi.updatePolicy, id, data);
    yield put(actions.updatePolicySuccess(response.data));
    message.success('Policy updated successfully');

    if (callback) {
      callback(response.data);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Failed to update policy';
    yield put(actions.updatePolicyFailure(errorMsg));
    message.error(errorMsg);
  }
}

// ── Delete Policy ───────────────────────────────────────────────

function* deletePolicySaga(action) {
  try {
    const { id, callback } = action.payload;
    yield call(cloudResourcesApi.deletePolicy, id);
    yield put(actions.deletePolicySuccess(id));
    message.success('Policy deleted successfully');

    if (callback) {
      callback();
    }
  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Failed to delete policy';
    yield put(actions.deletePolicyFailure(errorMsg));
    message.error(errorMsg);
  }
}

// ── Watcher Saga ────────────────────────────────────────────────

export default function* policiesSaga() {
  yield takeLatest(types.FETCH_POLICIES_REQUEST, fetchPoliciesSaga);
  yield takeLatest(types.FETCH_POLICY_REQUEST, fetchPolicySaga);
  yield takeLatest(types.CREATE_POLICY_REQUEST, createPolicySaga);
  yield takeLatest(types.UPDATE_POLICY_REQUEST, updatePolicySaga);
  yield takeLatest(types.DELETE_POLICY_REQUEST, deletePolicySaga);
}
